import React, {FC, useEffect, useRef} from "react"
import {Button, CheckBox} from "@dv5/components"
import {CanvasSettings} from "@dv5/domain"
import "./CanvasOptionsDialog.less"

interface Props {
    isOpen: boolean
    onClose: () => void
    canvasId: string
    settings: CanvasSettings
    onToggleReadOnly: (value: boolean) => void
    onToggleDisplayGrid: (value: boolean) => void
    onToggleAlignToGrid: (value: boolean) => void
    onToggleMarkdownComments: (value: boolean) => void
}

export const CanvasOptionsDialog: FC<Props> = ({
                                                   isOpen,
                                                   onClose,
                                                   canvasId,
                                                   settings,
                                                   onToggleReadOnly,
                                                   onToggleDisplayGrid,
                                                   onToggleAlignToGrid,
                                                   onToggleMarkdownComments,
                                               }) => {
    const dialogRef = useRef<HTMLDivElement>(null)

    useEffect(() => {
        const handleKeyDown = (e: KeyboardEvent) => {
            if (e.key === 'Escape') {
                e.preventDefault()
                onClose()
            }
        }

        if (isOpen) {
            document.addEventListener('keydown', handleKeyDown)
        }

        return () => document.removeEventListener('keydown', handleKeyDown)
    }, [isOpen, onClose])

    if (!isOpen) return null

    const handleOverlayClick = (e: React.MouseEvent<HTMLDivElement>) => {
        if (dialogRef.current && !dialogRef.current.contains(e.target as Node)) {
            onClose()
        }
    }

    const handleDone = () => {
        onClose()
    }

    const handleCancel = () => {
        onClose()
    }

    return (
        <div className="canvas-options-dialog-overlay" onClick={handleOverlayClick}>
            <div
                className="canvas-options-dialog"
                ref={dialogRef}
                onClick={(e) => e.stopPropagation()}
            >
                <div className="canvas-options-dialog-header">
                    <h3>Options</h3>
                </div>
                <div className="canvas-options-dialog-body">
                    {settings && <React.Fragment>
                        <CheckBox label="Read only" value={settings.readOnly}
                                  setValue={onToggleReadOnly} className="canvas-options-dialog-checkbox" />
                        <CheckBox
                            label="Display grid"
                            value={settings.displayGrid}
                            setValue={onToggleDisplayGrid}
                            className="canvas-options-dialog-checkbox"
                        />
                        <CheckBox
                            label="Align to grid"
                            value={settings.alignToGrid}
                            setValue={onToggleAlignToGrid}
                            className="canvas-options-dialog-checkbox"
                        />
                        <CheckBox
                            label="Comments as Markdown"
                            value={settings.markdownComments}
                            setValue={onToggleMarkdownComments}
                            className="canvas-options-dialog-checkbox"
                        />
                    </React.Fragment>}
                </div>
                <div className="canvas-options-dialog-footer">
                    <Button title="Cancel" onClick={handleCancel} className="canvas-options-dialog-cancel-btn" />
                    <Button title="Done" onClick={handleDone} className="canvas-options-dialog-done-btn" />
                </div>
            </div>
        </div>
    )
}